module.exports = "console.log('you can use ES6 here : )')\n"


//////////////////
// WEBPACK FOOTER
// ./assets/js/index.js
// module id = 1
// module chunks = 10 11